module.exports = __webpack_public_path__ + "static/media/grossMarginGradient.733d7572.svg";